import { gql } from "apollo-boost";

export default gql`
  mutation createProductBase($input: NewProductBase!) {
    createProductBase(input: $input) {
      id
      title
      mockup
      sku
      designs {
        id
        name
        description
        fileId
        width
        height
      }
      description
      attributes
      autoRender
      renderAttrName
      images {
        id
        key
        fileName
        fileMime
        fileSize
        thumbnail
      }
      carriers {
        id
        name
      }
      category {
        id
        title
      }
      type {
        id
        category
      }
      fulfillService {
        id
        name
      }
      variants {
        id
        baseId
        attributes
        regularPrice
        basePrice
        salePrice
        ordering
      }
    }
  }
`;
